import { atom } from "recoil";

export const cashMovementsState = atom({
  key: "cashMovementsState",
  default: {
    enabled: false,
    canConfigure: false,
    loading: true,
    error: null,
  },
});
